import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeByIdController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeByIdController.php
* @route '/api/payment-mode/{payment_mode}'
*/
const GetPaymentModeByIdController = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentModeByIdController.url(args, options),
    method: 'get',
})

GetPaymentModeByIdController.definition = {
    methods: ["get","head"],
    url: '/api/payment-mode/{payment_mode}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeByIdController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeByIdController.php
* @route '/api/payment-mode/{payment_mode}'
*/
GetPaymentModeByIdController.url = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { payment_mode: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { payment_mode: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            payment_mode: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        payment_mode: typeof args.payment_mode === 'object'
        ? args.payment_mode.id
        : args.payment_mode,
    }

    return GetPaymentModeByIdController.definition.url
            .replace('{payment_mode}', parsedArgs.payment_mode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeByIdController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeByIdController.php
* @route '/api/payment-mode/{payment_mode}'
*/
GetPaymentModeByIdController.get = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetPaymentModeByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PaymentMode\GetPaymentModeByIdController::__invoke
* @see app/Http/Controllers/PaymentMode/GetPaymentModeByIdController.php
* @route '/api/payment-mode/{payment_mode}'
*/
GetPaymentModeByIdController.head = (args: { payment_mode: string | number | { id: string | number } } | [payment_mode: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetPaymentModeByIdController.url(args, options),
    method: 'head',
})

export default GetPaymentModeByIdController